import { Controller } from '@hotwired/stimulus';
import { AlertController } from '@elc-online/edl-components/js/alert';

export default class extends Controller {
  static readonly targets = ['container', 'close'];

  declare containerTarget: HTMLButtonElement;
  declare closeTarget: HTMLButtonElement;

  initialize(): void {
    new AlertController(
      {
        container: this.containerTarget,
        close: this.closeTarget,
      },
      {
        mode: 'auto',
      },
    );
  }
}
